import React, { useState, useRef } from "react";
import axios from "axios";
import PageTitle from "../../components/PageTitle";
import { toggleMenu } from "../../utils/helpers";
import { MdDelete } from "react-icons/md";
import { FaRegFileAlt } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import styles from "../../Styles/modules/appraisal.module.css";
import Cookies from "js-cookie";
import APPRAISAL from "../../config/api/appraisal";
import { toast } from "react-toastify";
import BulkFileUploader from "../../components/BulkFileUploader";

const UploadAppraisal = ({ title, description }) => {
  return (
    <>
      <div className="wrapper-body">
        <div className="page-heading">
          <div
            id="showMenuBtn"
            className="collapse-button"
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
          <PageTitle title={title} description={description} />
        </div>

        <div className="card d-flex justify-content-center align-items-center flex-column">
          <BulkFileUploader
            uploadUrl={APPRAISAL.UPLOAD_BULK_APPRAISALS}
            title={title}
            acceptedTypes={["xls", "xlsx"]}
          />
        </div>
      </div>
    </>
  );
};

export default UploadAppraisal;
